import React from 'react'

import { Usage } from '@at/design-system-patterns'
import {
    StyledAdvertImage,
    StyledAdvertImageContainer,
    StyledImageLoading,
    StyledImageLoadingText,
} from '../search-listing-image-section/search-listing-image-section.styles'
import { IconPhotograph } from '@at/design-system-icons'
import { createBackgroundImageUrl } from '../search-listing-image-section/image.util'

export const AdvertImageWithBlur = ({
    src = '',
    index,
    title,
    hideImage,
    alwaysEager,
    altText,
    resolution,
}: {
    src: string
    index: number
    title?: string
    hideImage: boolean
    alwaysEager?: boolean
    altText?: string
    resolution?: number
}) => {
    const loading = alwaysEager ? 'eager' : index !== 1 ? 'eager' : 'lazy' // eager load 1st image and lazy load 2nd image as not visible - eager load subsequent images when scrolling carousel
    const fetchPriority = index !== 1 ? 'high' : undefined
    const alt = altText || `Main listing image - ${title}`
    const resolutionValue = resolution || 260

    return !hideImage ? (
        <StyledAdvertImageContainer>
            <StyledAdvertImage
                src={createBackgroundImageUrl(src, resolutionValue)}
                fetchpriority={fetchPriority}
                loading={loading}
                decoding={index > 0 ? 'sync' : 'async'}
                usage={Usage.Result}
                pageBreakpoints={{
                    '480': 300,
                    '340': 1024,
                    '260': 768,
                }}
                className="blur-image"
            />
            <StyledAdvertImage
                src={src}
                alt={alt}
                fetchpriority={fetchPriority}
                loading={loading}
                decoding={index > 0 ? 'sync' : 'async'}
                usage={Usage.Result}
                pageBreakpoints={{
                    '480': 300,
                    '340': 1024,
                    '260': 768,
                }}
                className="main-image"
            />
        </StyledAdvertImageContainer>
    ) : (
        <StyledImageLoading>
            <IconPhotograph title="" />
            <StyledImageLoadingText>Loading...</StyledImageLoadingText>
        </StyledImageLoading>
    )
}
